import { TPropertyTypeV2 } from '../../../interfaces/src/property-v2.interface'
import { IPropertyShareData } from '../interfaces'

export const propertyTypesArr = [
  'APARTMENT',
  'BUILDING',
  'CONSULTING_ROOM',
  'COTTAGE',
  'DUPLEX_HOUSE',
  'EVENT_HALL',
  'HOTEL',
  'HOUSE',
  'INDUSTRIAL_BUILDING',
  'OFFICE',
  'OTHER',
  'RANCH',
  'SHOP_SHOPPING_CENTER',
  'SHOP',
  'TERRAIN',
  'WAREHOUSE'
] as const


export type PropertyTypesKeys = (typeof propertyTypesArr)[number]

export const PROPERTY_TYPE_DESCRIPTION: Record<TPropertyTypeV2, string> = {
  HOUSE: 'Casa',
  DUPLEX_HOUSE: 'Casa dúplex',
  COUNTRY_HOUSE: 'Quinta Campestre',
  APARTMENT: 'Departamento',
  OFFICE: 'Oficina',
  CONSULTING_ROOM: 'Consultorio',
  WAREHOUSE: 'Bodega',
  INDUSTRIAL_BUILDING: 'Nave industrial',
  SHOP: 'Local',
  SHOP_SHOPPING_CENTER: 'Local en centro comercial',
  TERRAIN: 'Terreno/Lote',
  RANCH: 'Rancho/Hacienda',
  BUILDING: 'Edificio',
  HOTEL: 'Hotel',
  EVENT_HALL: 'Salón/Terraza de eventos',
  COTTAGE: 'Cabaña',
  OTHER: 'Otro',
  APARTMENT_CONDO: 'Departamento en condominio',
  HOUSE_CONDO: 'Casa en condominio',
  HOUSE_RESIDENTIAL: 'Casa residencial'
}

export const moreThan20Lines = (descripcion: string) => {
  const lines = descripcion?.toString()?.split('\n')
  const linesWithContent = lines?.filter((line) => line?.trim() !== '')
  return linesWithContent?.length > 20
}

export const SHOW_MODALS = {
  showDownloadModal: false,
  showEditModal: false,
  showMainModal: false
}

const errorPdfMessagesMap = {
  'Not enough data needed to create pdf':
    'No hay suficientes datos para generar el PDF.',
  "The images can't be empty":
    'Error al descargar: La propiedad debe tener más de 1 imagen.',
  "The title can't be empty":
    'Error al descargar: El título de la propiedad no puede estar vacío.',
  "The description can't be empty":
    'Error al descargar: La descripción de la propiedad no puede estar vacía.',
  '"property.custom_title" must be a string':
    'Error al descargar: El título de la propiedad no puede estar vacío.',
  '"property.custom_description" must be a string':
    'Error al descargar: La descripción de la propiedad no puede estar vacía.',
  '"property.custom_cover_image" is not allowed to be empty':
    'Error al descargar: La imagen de portada de la propiedad no existe.',
  '"property.property_type" is not allowed to be empty':
    'Error al descargar: El tipo de propiedad no puede estar vacío.',
  '"property.operation_type" does not contain 1 required value(s)':
    'Error al descargar: El tipo de operación no puede estar vacío.',
  '"property.images" does not contain 1 required value(s)':
    'Error al descargar: Las imágenes de la propiedad no pueden estar vacías.',
  '"property.state" is required': 'Error al descargar: El estado es requerido.',
  '"property.state" is not allowed to be empty':
    'Error al descargar: El estado no puede estar vacío.',
  '"property.city" is required': 'Error al descargar: La ciudad es requerida.',
  '"property.city" is not allowed to be empty':
    'Error al descargar: La ciudad no puede estar vacía.',
  '"user.email" is not allowed to be empty':
    'Completa tu correo electrónico para poder generar el pdf.',
  '"user.phone_number" is not allowed to be empty':
    'Completa tu número de teléfono para poder generar el pdf.',
  '"user.fullname" is not allowed to be empty':
    'Completa tu nombre y apellido para poder generar el pdf.',
  '"user.photo" is not allowed to be empty':
    'Completa tu foto de perfil para poder generar el pdf.',
  '"property.neighborhood" must be a string':
    'Error al descargar: La colonia es requerida.',
  '"property.neighborhood" is not allowed to be empty':
    'Error al descargar: La colonia no puede estar vacía.'
}

export const matchAndTranslateErrorMessage = (message: string) => {
  return (
    errorPdfMessagesMap[message as keyof typeof errorPdfMessagesMap] ||
    'Ocurrió un error desconocido. Por favor, inténtalo nuevamente.'
  )
}

export const generateSlugVip = (property: IPropertyShareData): string => {
  const parsedPropertyType =
    (
      PROPERTY_TYPE_DESCRIPTION[
        property.propertyType as keyof typeof PROPERTY_TYPE_DESCRIPTION
      ] ?? ''
    ).toLowerCase() ?? ''

  const operationTypes = []
  if (property?.saleActive) {
    if (
      property?.antiquity === 'NEW' &&
      parsedPropertyType === 'departamento'
    ) {
      operationTypes.push('nuevo-en-venta')
    } else if (property?.antiquity === 'NEW' && parsedPropertyType === 'casa') {
      operationTypes.push('nueva-en-venta')
    } else {
      operationTypes.push('en-venta')
    }
  }

  if (property?.leaseActive) {
    operationTypes.push('en-renta')
  }

  if (property?.presaleActive) {
    operationTypes.push('en-preventa')
  }
  const parsedOparation = operationTypes.join('_')

  const slug = `${parsedPropertyType}-${parsedOparation}-${
    property?.street?.trim() ?? ''
  }-${property?.neighborhood?.trim() ?? ''}-${property?.city?.trim() ?? ''}-${
    property?.state?.trim() ?? ''
  }`
  const formatedSlug = slug
    .toLowerCase()
    .replace(/\s/g, '-')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9 _-]/g, '')

  return `${formatedSlug}-${property.legacyId}`.replace('ciudad-de-mexico', 'cdmx')
}
